import { Config, vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

@vsingleton()
export class NotificationApiRoute extends RouteBase {
  prefix = 'api.v1.notifications.'
  userType: string = (Config.get('userType') === 'panel') ? 'user' : Config.get('userType')

  bell() {
    return this.ziggyRoute('bell', { user_type: this.userType })
  }

  all() {
    return this.ziggyRoute('index', { user_type: this.userType })
  }

  markAllAsRead() {
    return this.ziggyRoute('mark_all_as_read', { user_type: this.userType })
  }
}

@vsingleton()
export class NotificationRoute extends RouteBase {
  userType = Config.get('userType')
  prefix = `${this.userType}.notification.`

  index() {
    return this.ziggyRoute('index')
  }
}

